/**
 * Beach stickers — authored via the `/pack` toile process (plan
 * `thinking/plans/2026_08_31_toile_pack_wiring.md` Track B), wave `toile_stickers`. Narcis file-split
 * shape (Track A): one module per pack, `registry.ts` assembles them into `livePacks`.
 */
import {tagline, chips, type ToilePack} from './data'

export const beachStickersPack: ToilePack = {
    slug: 'beach-stickers',
    category: 'sticker',
    name: 'Beach stickers',
    tagline: tagline('pieces', 'themes', 'styles'),
    chips: chips('themes', 'styles'),
    ratio: {w: 1024, h: 1024},
    readings: [
        {key: 'umbrella', label: 'Beach umbrella', subject: 'a striped beach umbrella planted in sand'},
        {key: 'wave', label: 'Wave', subject: 'a curling wave with foam'},
        {key: 'flipflops', label: 'Flip-flops', subject: 'a pair of flip-flops side by side'},
    ],
    styles: [
        {key: 'retro', label: 'Retro', style: 'retro sticker illustration, 1970s shapes, halftone grain, slight misregistration', palette: 'Mustard, rust, teal and cream', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'bold', label: 'Bold cartoon', style: 'bold cartoon sticker, thick black outlines, bright flat fills, slight gloss', palette: 'Bright saturated primaries with black outlines', framing: 'Each sticker isolated with a thick white die-cut border on a plain ground'},
        {key: 'minimal', label: 'Minimal line', style: 'minimal single-line sticker, one clean continuous line, no fill', palette: 'Black line only, one accent colour', framing: 'Each sticker isolated with a thin white die-cut border on a plain ground'},
    ],
    directions: ['a palm tree instead', 'for a water bottle', 'at sunset'],
    directionHint: 'try: a palm tree instead',
    seo: {
        title: 'Beach Stickers: Umbrella, Wave, Flip-Flops',
        metaDescription: 'Nine summer beach stickers — a striped umbrella, a wave, a flip-flop pair — in retro, bold cartoon, and minimal line styles.',
        h1: 'Beach stickers: striped umbrella, wave, flip-flops',
        tagline: 'Nine stickers, three summer icons, three styles each.',
        intro: 'A striped beach umbrella planted in sand, a curling wave with foam, and a pair of flip-flops side by side — three summer stickers, die-cut and ready to print. Each rendered retro, bold cartoon, and minimal single-line. Ask for a surfboard instead, a sunset scene, or a beach-bag composition, and the same three styles carry it.',
        useCases: [
            'a water bottle or beach bag',
            'a planner or summer journal',
            'a laptop or phone case',
            'a summer party favour',
        ],
        faq: [
            {q: "What's in this pack?", a: 'Nine summer stickers — a striped beach umbrella, a wave, and flip-flops — in retro, bold cartoon, and minimal line finishes.'},
            {q: 'Can I get a surfboard or a sunset scene?', a: 'Yes — the direction field takes any variation, including a surfboard instead, a sunset scene, or a beach-bag composition.'},
            {q: 'What size should I print these at?', a: 'Each sticker is a square die-cut design, so it scales cleanly from a small vinyl sticker to a full A4 sheet.'},
            {q: 'Are these waterproof once printed?', a: 'That depends on the vinyl stock and laminate your printer uses — the artwork itself is print-ready at any common sticker size.'},
        ],
    },
}
